<template>
  <div class="content">
    <div class="content-select">
      <el-row :gutter="20">
        <el-col :span="4">
          <div class="select-title">
            <div class="title-img">
              <img src="@/assets/appraisal/select-icon.png" alt="">
            </div>
            <div class="title-info">
              <span>案件认定</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="content-header">
      <myTableSearch :isOperate="true" :operateWidth="350" :formData="formData" :tableLabel="tableLabel"
                     :queryFn="queryFn" :queryParams="queryParams" :searchColLg="6" ref="tableRef" dataRow="rows"
                     :isSelection="false" :rowClassName="tableRowClassName">
        <template slot="caseStatus" slot-scope="scope">
					<span :style="{ 
						display: 'inline-flex', 
						alignItems: 'center', 
						justifyContent: 'center',
						minWidth: '60px',
						height: '24px',
						padding: '0 12px',
						borderRadius: '4px',
						fontSize: '12px',
						color: '#fff',
						backgroundColor: scope.row.caseStatus == 1 ? 'rgb(252, 177, 34)' : 'rgb(32, 201, 128)'
					}">
						{{ scope.row.caseStatus == 1 ? '待认定' : '已认定' }}
					</span>
        </template>
        <template #remainingPrompts="scope">
          <span :class="getRemainingPromptTextClass(scope.row)">
            {{ formatRemainingPromptsCell(scope.row) }}
          </span>
        </template>
        <template slot="tool">
          <div class="toolbar-container">
            <div class="toolbar-left">
              <div class="tool-btn" @click="handleRefresh" title="刷新">
                <img :src="refreshIcon" alt="刷新" class="toolbar-icon">
              </div>
            </div>
            <div class="toolbar-right">
              <el-button icon="el-icon-fake custom-icon icon-policy-download" type="primary" :loading="exportCaseLoading" @click="handleExportCase">
                案件导出
              </el-button>
            </div>
          </div>
        </template>
        <template slot="operate" slot-scope="scope">
          <el-button @click="handleView(scope.row)" size="small" type="text">查看详情</el-button>
          <el-button @click="handleOpinion(scope.row,1)" v-if="scope.row.caseStatus==1" size="small" type="text">
            认定意见
          </el-button>
          <el-button @click="handleSend(scope.row)" size="small" type="text">生成公告文书</el-button>
          <el-button @click="handleOpinion(scope.row,2)" v-if="scope.row.caseStatus==2" size="small" type="text">
            修改认定意见
          </el-button>
        </template>
      </myTableSearch>
      <!-- 导入结果 -->
      <importResultDialog v-if="isImportResultDialog" :isDialog="isImportResultDialog" :resultData="importResultData"
                          @handleClose="isImportResultDialog = false">
      </importResultDialog>
      <!-- 认定意见弹窗（点击某行「认定意见」时打开对应案件弹框） -->
      <opinion
          :isDialog="isOpinionDialog"
          :case-id="opinionRowData.id"
          @handleClose="handleCloseOpinion"
          v-if="isOpinionDialog"
          :type="type"
      />
      <!-- 文书管理弹窗（点击某行「送达文书」时打开） -->
      <sendDocumentDialog
          :isDialog="isSendDocumentDialog"
          :rowData="sendDocumentRowData"
          @handleClose="isSendDocumentDialog = false"
      />
    </div>
  </div>
</template>

<script>
import '@/assets/css/base.css'
import {getListByDictType} from '@/api/sys/dictData'
import importResultDialog from './components/importResultDialog.vue'
import opinion from './components/opinion/index.vue'
import sendDocumentDialog from './components/sendDocumentDialog.vue'
import refreshIcon from '@/assets/pages/appointment/refresh.png'
import {getDetermineList,exportCase} from '@/api/recognition/determine'
import {downLoadFile} from "@/utils/downLoad";

export default {
  name: 'PolicyList',
  components: {
    importResultDialog,
    opinion,
    sendDocumentDialog
  },
  data() {
    return {
      refreshIcon,
      currentPage: 1,
      downloadTemplateLoading: false,
      importLoading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        pageSizes: [10, 20, 50]
      },
      isSubscribeDialog: false,//新增/编辑/查看政策弹窗
      isEdit: false,//是否为编辑模式
      isView: false,//是否为查看模式
      editData: {},//编辑/查看时的数据
      isAcceptDialog: false,//受理审核弹窗
      acceptRowData: {},//受理时的行数据
      isAddCaseDialog: false,//新增案件弹窗
      isImportResultDialog: false,//导入结果弹窗
      importResultData: '',//导入结果
      isOpinionDialog: false,//认定意见弹窗
      opinionRowData: {},//认定意见当前行数据
      isSendDocumentDialog: false,//文书管理弹窗
      sendDocumentRowData: {},//送达文书当前行数据
      formData: [
        {
          label: '认定状态',
          type: 'select',
          key: 'caseStatus',
          colLg: 6,
          data: []
        },
        {
          label: '伤者姓名',
          type: 'input',
          key: 'woundedName',
          colLg: 6,
          placeholder: '伤者姓名'
        },
        {
          label: '用人单位名称',
          type: 'input',
          key: 'unitName',
          colLg: 6,
        },
        {
          label: '案件编号',
          type: 'input',
          key: 'caseCode',
          colLg: 6,
          placeholder: '案件编号'
        },
        {
          label: '事故发生日期',
          type: 'daterange',
          format: 'yyyy-MM-dd',
          key: 'accidentDate',
          colLg: 12,
          placeholder: '事故发生',
          screen: (value) => {
            if (value && value.length === 2) {
              return {
                accidentDateStart: value[0],
                accidentDateEnd: value[1]
              }
            }
            return {}
          }
        },
        {
          label: '受理日期',
          type: 'daterange',
          format: 'yyyy-MM-dd',
          key: 'applyDateTime',
          colLg: 12,
          placeholder: '受理日期',
          screen: (value) => {
            if (value && value.length === 2) {
              return {
                applyDateStart: value[0],
                applyDateEnd: value[1]
              }
            }
            return {}
          }
        },
        {
          label: '认定日期',
          type: 'daterange',
          format: 'yyyy-MM-dd',
          key: 'determineDate',
          colLg: 12,
          placeholder: '认定日期',
          screen: (value) => {
            if (value && value.length === 2) {
              return {
                identificationDateStart: value[0],
                identificationDateEnd: value[1]
              }
            }
            return {}
          }
        },
        {
          label: '承办人',
          type: 'input',
          key: 'acceptUserName',
          colLg: 6,
          placeholder: '承办人'
        },
        {
          label: '认定结论',
          type: 'select',
          key: 'identificationClauseCode',
          colLg: 6,
          data: [
            {
              dictLabel:'全部',
              dictValue:[]
            },
            {
              dictLabel:'予以认定为工伤',
              dictValue:[1,2,3,4,5,6,7]
            },
            {
              dictLabel:'予以视同为工伤',
              dictValue: [8,9,10]
            },{
              dictLabel:'不予认定为工伤',
              dictValue:[11,12,13,14]
            },
            {
              dictLabel:'撤销',
              dictValue:[15]
            }
          ]
        },
        {
          label: '认定条款',
          type: 'input',
          key: 'identificationClauseName',
          colLg: 6,
          placeholder: '认定条款，如 14.1'
        },
      ],
      tableLabel: [
        {
          prop: 'caseCode',
          label: '案件编号',
          minWidth: 150
        },
        {
          prop: 'applyDate',
          label: '申请日期',
          minWidth: 300
        },
        {
          prop: 'woundedName',
          label: '伤者姓名',
          width: 200
        },
        {
          prop: 'unitName',
          label: '用人单位',
          minWidth: 200
        },
        {
          prop: 'accidentHarmTypeName',
          label: '伤害类型',
          minWidth: 200
        },
        {
          prop: 'accidentDate',
          label: '事故日期',
          minWidth: 200
        },
        {
          prop: 'acceptUserName',
          label: '承办人',
          width: 100
        },
        {
          prop: 'caseStatus',
          label: '案件状态',
          width: 100
        },
        {
          prop: 'remainingPrompts',
          label: '剩余提示',
          width: 140,
          isTooltip: false
        }
      ],
      exportCaseLoading:false,
      type:1
    }
  },
  mounted() {
    this.loadPolicyTagData()
  },
  methods: {
    handleCloseOpinion(){
      this.isOpinionDialog = false;
      this.$refs.tableRef && this.$refs.tableRef.handleSearch();
    },
    // 获取列表数据
    queryFn(queryParams) {
      return getDetermineList(queryParams)
    },
    // 获取政策标签字典
    async loadPolicyTagData() {
      const res = await getListByDictType('policy_info_label')
      if (res && res.code === 200 && res.data) {
        this.updateFormDataWithPolicyTag(res.data)
      }
      const res1 = await getListByDictType('determination_case_status')
      if (res1 && res1.code === 200 && res1.data) {
        res1.data.unshift({
          dictLabel: '全部',
          dictValue: ''
        })
        this.formData[0].data=res1.data
      }
    },
    // 更新政策标签下拉选项
    updateFormDataWithPolicyTag(tagData) {
      if (!tagData) return

      const tagIndex = this.formData.findIndex(item => item.key === 'labelCode')
      if (tagIndex !== -1) {
        // 在数据开头添加"全部"选项
        const dataWithAll = [
          {
            dictLabel: '全部',
            dictValue: ''
          },
          ...tagData
        ]
        this.$set(this.formData[tagIndex], 'data', dataWithAll)
      }
    },
    // 上一页
    handlePrevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.queryParams.pageNum = this.currentPage;
        this.$refs.tableRef && this.$refs.tableRef.handleSearch();
      }
    },
    // 下一页
    handleNextPage() {
      this.currentPage++;
      this.queryParams.pageNum = this.currentPage;
      this.$refs.tableRef && this.$refs.tableRef.handleSearch();
    },
    // 刷新列表
    handleRefresh() {
      this.queryParams.pageNum = 1;
      this.currentPage = 1;
      this.$refs.tableRef && this.$refs.tableRef.handleSearch();
    },

    // 查看详情
    handleView(row) {
      this.$router.push({
        path: '/work/Management/detail',
        query: {
          id: row.id,
          pageType: '2'
        }
      })
    },
    // 认定意见
    handleOpinion(row,type) {
      this.opinionRowData = row || {}
      this.isOpinionDialog = true
      this.type=type
    },
    // 送达文书：打开文书管理弹窗
    handleSend(row) {
      this.sendDocumentRowData = row || {}
      this.isSendDocumentDialog = true
    },
    // 导出案件（待实现）
    handleExportCase() {
      this.exportCaseLoading = true
      exportCase({...this.queryParams.query}).then(res => {
        if (res) {
          downLoadFile(res,'案件认定',new Date().getTime(),'xls')
        }
      }).finally(() => {
        this.exportCaseLoading = false
      })
    },
    isOverdueRemainingPrompt(row) {
      const t = row && row.remainingPrompts
      if (t == null || t === '') return false
      return /超期/.test(String(t))
    },
    getRemainingDaysFromRow(row) {
      if (!row) return null
      if (typeof row.remainingDays === 'number' && !Number.isNaN(row.remainingDays)) {
        return row.remainingDays
      }
      const t = row.remainingPrompts
      if (t == null || t === '') return null
      const s = String(t)
      if (/超期/.test(s)) return null
      const m = s.match(/剩余\s*(\d+)\s*天/) || s.match(/还剩\s*(\d+)\s*天/)
      if (m) return parseInt(m[1], 10)
      return null
    },
    getRemainingRowVisualState(row) {
      if (this.isOverdueRemainingPrompt(row)) return 'overdue'
      const days = this.getRemainingDaysFromRow(row)
      if (days !== null && days <= 15) return 'warning'
      return null
    },
    formatRemainingPromptsCell(row) {
      const v = row && row.remainingPrompts
      if (v === null || v === undefined || v === '') return '-'
      return v
    },
    getRemainingPromptTextClass(row) {
      if (this.isOverdueRemainingPrompt(row)) {
        return 'remaining-prompt-text remaining-prompt-text--error'
      }
      if (this.getRemainingRowVisualState(row) === 'warning') {
        return 'remaining-prompt-text remaining-prompt-text--warning'
      }
      return ''
    },
    tableRowClassName({ row }) {
      const state = this.getRemainingRowVisualState(row)
      if (state === 'overdue') return 'row-remaining-overdue'
      if (state === 'warning') return 'row-remaining-warning'
      if (row.woundedBlack || row.unitBlack) {
        return 'row-highlight'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;

  &-select {
    height: 50px;

    .select-title {
      height: 46px;
      background: url('~@/assets/appraisal/selectBg.png') no-repeat;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      gap: 12px;
      padding-left: 16px;

      .title-img {
        width: 18px;
        height: 18px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .title-info {
        color: var(--vt-c-black-mute-soft);
        font-size: 16px;
        font-weight: 700;
      }
    }

    .select-serch {
      margin-top: 12px;
      display: flex;
      align-items: center;
      gap: 8px;

      .serch-hint {
        color: var(--vt-c-black-mute-soft);
        font-size: 14px;
        font-weight: 400;
      }

      .serch-info {
        height: 28px;
        display: flex;
        align-items: center;
        gap: 12px;

        .info-item {
          width: 120px;
          height: 28px;
          text-align: center;
          line-height: 28px;
          background: var(--vt-c-blue-mute);
          color: var(--vt-c-blue);
          border-radius: 2px;
          cursor: pointer;
          transition: all 0.3s ease;

          &:hover {
            opacity: 0.8;
          }

          &.active {
            background: var(--vt-c-blue);
            color: var(--vt-c-white);
          }

          &:active:not(.active) {
            transform: scale(0.98);
          }
        }
      }
    }
  }

  &-header {
    margin-top: 16px;
    padding: 0 24px;

    /deep/ .myTableSearch {
      padding: 0;
    }
  }
}

.link-text {
  color: #409eff;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.toolbar-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;

  .toolbar-icon {
    width: 24px;
    height: 24px;
  }

  .add-icon {
    width: 20px;
    height: 20px;
    margin-right: 6px;
  }

  .toolbar-left {
    display: flex;
    align-items: center;
    gap: 12px;

    .tool-btn {
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #dcdfe6;
      cursor: pointer;
      transition: all 0.2s;
      background-color: #FCFCFCFF;
    }

    .list-title {
      font-size: 14px;
      font-weight: 400;
      color: var(--vt-c-blue-soft);
    }
  }

  .toolbar-right {
    display: flex;
    align-items: center;
    gap: 12px;

    .import-upload {
      display: inline-block;

      /deep/ .el-upload {
        display: inline-block;
      }
    }

    .el-button {
      height: 36px;
      padding: 0 16px;
    }
  }
}
.content-header{
  flex: 1;
  display: flex;
  flex-flow: column;
  overflow-y: hidden;
}
/deep/.row-highlight{
  background-color: #d9af891a !important;
  >.el-table__cell:nth-child(1){
    border-left: 4px solid #faad14;
  }
}
/deep/ tr.row-remaining-warning {
  background-color: rgba(250, 173, 20, 0.18) !important;
  > .el-table__cell {
    background-color: rgba(250, 173, 20, 0.18) !important;
  }
  > .el-table__cell:nth-child(1) {
    border-left: 4px solid #e6a23c;
  }
}
/deep/ .el-table__fixed tr.row-remaining-warning > .el-table__cell {
  background-color: rgba(250, 173, 20, 0.18) !important;
}
/deep/ tr.row-remaining-overdue {
  background-color: rgba(245, 108, 108, 0.14) !important;
  > .el-table__cell {
    background-color: rgba(245, 108, 108, 0.14) !important;
  }
  > .el-table__cell:nth-child(1) {
    border-left: 4px solid #f56c6c;
  }
}
.remaining-prompt-text--error {
  color: #f56c6c;
  font-weight: 600;
}
/deep/ tr.row-remaining-overdue .remaining-prompt-text--error {
  color: #f56c6c !important;
}
/deep/ .el-table__fixed tr.row-remaining-overdue > .el-table__cell {
  background-color: rgba(245, 108, 108, 0.14) !important;
}
.remaining-prompt-text--warning {
  color: #e6a23c;
  font-weight: 500;
}
/deep/.el-table__fixed-right{
  background-color: #fff;
}
</style>